/**
 * Thresholds for measuring the IMU-to-GPS clock offset from the gyro yaw
 * rate against the GPS heading rate. Tuning any value here: edit →
 * `npm run build` in src/PitBrain.Shared → restart/rebuild the clients.
 */

/** Unit: ms. Largest offset searched in either direction. Default: 1500 */
export const IMU_LAG_MAX_MS = 1500

/** Unit: ratio. Yaw/heading-rate correlation below this means no usable estimate. Default: 0.6 */
export const IMU_LAG_MIN_CORRELATION = 0.6

/** Unit: km/h. Points below this speed do not inform the estimate. Default: 40 */
export const IMU_LAG_MIN_SPEED_KMH = 40

/** Unit: s. Window length for the drift estimate. Default: 120 */
export const IMU_LAG_DRIFT_WINDOW_S = 120

/** Unit: ratio. A drift window with fewer moving points than this is skipped. Default: 0.5 */
export const IMU_LAG_MIN_MOVING_FRACTION = 0.5

/** Unit: s. Least riding above the speed floor for any estimate. Default: 30 */
export const IMU_LAG_MIN_RIDING_S = 30

/**
 * Unit: ms. Half-length of the position chords whose headings give the GPS
 * heading rate: the chord from the fix nearest to t − 500 ms to the point,
 * and from the point to the fix nearest to t + 500 ms. Adjacent fixes are
 * ±18° of heading each at 25 Hz under 0.25 m of position noise (yaw
 * correlation 0.01 on the synthetic field ride); these chords give 0.89
 * there and 0.95 / 0.91 on the real RaceBox / GoPro fixtures. Default: 500
 */
export const IMU_LAG_HEADING_HALF_WINDOW_MS = 500
